import * as React from 'react';
import Svg, { Circle } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10 10"
        width={props.size ?? 10}
        height={props.size ?? 10}
        fill="none"
        {...props}
    >
        <Circle cx={5} cy={5} r={5} fill={props.color ?? ds.colorValue.background.danger.strong} opacity={0.3} />
        <Circle cx={5} cy={5} r={2} fill={props.color ?? ds.colorValue.background.danger.strong} />
    </Svg>
);
export { SvgComponent as LiveIcon };
